import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { PasswordReset } from "@/pages/password-reset/PasswordReset";

const searchParams = z.object({
	token: z.coerce.string(),
});

export const Route = createFileRoute("/auth/password-reset")({
	head: () => ({
		meta: [{ title: "Reset Password - BitEasy" }],
	}),
	validateSearch: zodValidator(searchParams),
	component: PasswordReset,
});
